// extracted by css-extract-rspack-plugin
var _1 = "te";
var _2 = "tf";
var _3 = "h";
var _4 = "e1";
var _5 = "s9";
var _6 = "fn";
var _7 = "tg";
var _8 = "s6";
var _9 = "ta";
var _a = "fe";
var _b = "tc";
var _c = "tb";
var _d = "fa";
var _e = "aq";
var _f = "s7";
var _10 = "s8";
var _11 = "s5";
var _12 = "ln";
var _13 = "ar";
var _14 = "ff";
var _15 = "fh";
export { _1 as "availableButtonsLabel", _2 as "checkSection", _3 as "content", _4 as "description", _5 as "discountImage", _6 as "featuredOffers", _7 as "flyerCatalogueComponent", _8 as "flyerDetails", _9 as "flyerDetailsComponent", _a as "headerDescription", _b as "infoWrapper", _c as "infoWrapperDivision", _d as "invalid", _e as "leftColumn", _f as "mainContent", _10 as "navigation", _11 as "noNavigation", _12 as "pageTagsComponent", _13 as "rightColumn", _14 as "validity", _15 as "validityText" }
